// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iWBK","col":"styles_col__3oOzY"};